<template>
  <!-- 异步子树 chunk 加载期间的占位：填满父容器并居中显示品牌 spinner，避免出现空白。 -->
  <div class="async_view_loading" role="status" aria-live="polite">
    <div class="async_view_loading__spinner"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
.async_view_loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.async_view_loading__spinner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid rgba(var(--color-brand-1-rgb), 0.18);
  border-top-color: var(--brand-color-pure);
  // spin 关键帧定义在全局 common.less 中
  animation: spin 0.8s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .async_view_loading__spinner {
    animation-duration: 2s;
  }
}
</style>
